function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import { useCallback, useMemo, useRef, useState } from 'react';
import { usePersistentState } from '@deephaven/dashboard';
import { isIrisGridTableModelTemplate } from '@deephaven/iris-grid';
import { TablePluginWrapper } from "./TablePluginWrapper.js";
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * Hook to get a TablePlugin component and the IrisGrid props derived from the plugin.
 * The returned props should be passed to the IrisGrid component or merged with other sources
 * of the same props.
 * @param props The properties for the table plugin. The props object itself does not need to be memoized,
 *              but the values inside it should be stable to avoid unnecessary re-renders.
 * @returns Object containing `Plugin` key which is the Plugin component.
 *          The remaining object keys are IrisGrid props associated with the plugin.
 */
export function useTablePlugin(_ref) {
  var model = _ref.model,
    irisGridRef = _ref.irisGridRef,
    irisGridUtils = _ref.irisGridUtils,
    selectedRanges = _ref.selectedRanges;
  var _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    pluginFilters = _useState2[0],
    setPluginFilters = _useState2[1];
  var customFilters = useMemo(() => model != null && irisGridUtils != null && isIrisGridTableModelTemplate(model) ? irisGridUtils.getFiltersFromInputFilters(model.table.columns, pluginFilters, model.formatter.timeZone) : [], [model, irisGridUtils, pluginFilters]);
  var _useState3 = useState([]),
    _useState4 = _slicedToArray(_useState3, 2),
    alwaysFetchColumns = _useState4[0],
    setAlwaysFetchColumns = _useState4[1];
  var pluginRef = useRef(null);
  var _usePersistentState = usePersistentState(undefined, {
      version: 1,
      // pluginName will be undefined on first call when re-hydrating,
      // so use a constant type to avoid re-hydration issues with the persistent state type
      type: 'GridWidgetTablePluginState'
    }),
    _usePersistentState2 = _slicedToArray(_usePersistentState, 2),
    pluginState = _usePersistentState2[0],
    setPluginState = _usePersistentState2[1];
  var Plugin = useMemo(() => model != null && isIrisGridTableModelTemplate(model) && model.table.pluginName != null ? /*#__PURE__*/_jsx(TablePluginWrapper, {
    ref: pluginRef,
    name: model.table.pluginName,
    model: model,
    filter: setPluginFilters,
    fetchColumns: setAlwaysFetchColumns,
    selectedRanges: selectedRanges,
    irisGridRef: irisGridRef,
    pluginState: pluginState,
    onStateChange: setPluginState
  }) : null, [model, selectedRanges, irisGridRef, pluginState, setPluginState]);
  var onContextMenu = useCallback(data => {
    var _pluginRef$current$ge, _pluginRef$current, _pluginRef$current$ge2;
    return (_pluginRef$current$ge = (_pluginRef$current = pluginRef.current) === null || _pluginRef$current === void 0 || (_pluginRef$current$ge2 = _pluginRef$current.getMenu) === null || _pluginRef$current$ge2 === void 0 ? void 0 : _pluginRef$current$ge2.call(_pluginRef$current, data)) !== null && _pluginRef$current$ge !== void 0 ? _pluginRef$current$ge : [];
  }, []);
  return {
    Plugin,
    customFilters,
    alwaysFetchColumns,
    onContextMenu
  };
}
export default useTablePlugin;
//# sourceMappingURL=useTablePlugin.js.map